import { createContext, useContext, useState, useCallback } from "react";

const NotificationsContext = createContext(null);

export const NotificationsProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);

  const notify = useCallback((type, text) => {
    const id = Date.now();
    setMessages((prev) => [...prev, { id, type, text }]);
    setTimeout(() => {
      setMessages((prev) => prev.filter((m) => m.id !== id));
    }, 3000);
  }, []);

  const value = {
    success: (text) => notify("success", text),
    error: (text) => notify("error", text),
    info: (text) => notify("info", text),
  };

  return (
    <NotificationsContext.Provider value={value}>
      {children}
      <div className="notification-container">
        {messages.map((m) => (
          <div key={m.id} className={`notification notification-${m.type}`}>
            {m.text}
          </div>
        ))}
      </div>
    </NotificationsContext.Provider>
  );
};

export const useNotifications = () => {
  const ctx = useContext(NotificationsContext);
  if (!ctx) {
    throw new Error("useNotifications must be used within NotificationsProvider");
  }
  return ctx;
};
